export { default } from './ExternalScriptBlock';
